import { cn } from '@/components/ui/cn'
import { letterSectionId } from '@/lib/vocabularyGrouping'

interface AlphabetJumpBarProps {
  letters: string[]
  className?: string
}

export function AlphabetJumpBar({ letters, className }: AlphabetJumpBarProps) {
  if (letters.length <= 1) return null

  const scrollTo = (letter: string) => {
    document.getElementById(letterSectionId(letter))?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <nav
      aria-label="Jump to letter"
      className={cn(
        'sticky top-20 hidden max-h-[calc(100vh-6rem)] flex-col gap-0.5 overflow-y-auto xl:flex',
        className,
      )}
    >
      {letters.map((letter) => (
        <button
          key={letter}
          type="button"
          onClick={() => scrollTo(letter)}
          className="flex h-6 w-6 items-center justify-center rounded text-[11px] font-medium text-muted-foreground transition-colors hover:bg-primary/15 hover:text-primary"
        >
          {letter}
        </button>
      ))}
    </nav>
  )
}
